import { Status } from '@amzn/stencil-react-components/status-indicator';
import { ResponseStatus } from './responseStatus';

export const Frequency = Object.freeze({
  IMMEDIATE: 'IMMEDIATE',
  DAILY: 'DAILY',
  HOURLY: 'HOURLY',
  MONTHLY: 'MONTHLY',
  ONCE: 'ONCE',
  WEEKLY: 'WEEKLY',
});

export const CampaignSteps = Object.freeze({
  PENDING: 'PENDING',
  COMPLETE: 'COMPLETE',
  IN_PROGRESS: 'IN PROGRESS',
});

export const ChannelType = Object.freeze({
  EMAIL: 'EMAIL',
  SMS: 'SMS',
  SLACK: 'SLACK',
  CUSTOM: 'CUSTOM',
});

export const FormState = Object.freeze({
  VALID: 'valid',
  INVALID: 'invalid',
});

export const Message = Object.freeze({
  [ResponseStatus.ERROR]: 'Something went wrong. Please try again later.',
  [ResponseStatus.SUCCESS]: 'Campaign created successfully.',
});

export const FormErrorMessage = 'One or more form fields are missing.';

export const MULTI_CAMPAIGN_FORM_INFO =
  'Create a series of campaign with different segment, templates and schedule.\nMandatory fields Segment, template, start time, from address, end time, frequency, platform';

export const CampaignFormSection = Object.freeze({
  CAMPAIGN: 'campaign',
  SEGMENT: 'segment',
  TEMPLATE: 'template',
  SCHEDULE: 'schedule',
  REVIEW: 'review',
});

export const CampaignTypes = Object.freeze({
  STANDARD: 'STANDARD',
  AB: 'AB',
});

export const TemplateType = Object.freeze({
  NEW: 'NEW',
  EXISTING: 'EXISTING',
});

export const CAMPAIGN_FORM = [
  {
    label: 'Name a nudge campaign',
    stageLevel: 0,
    state: Status.Waiting,
    formStep: CampaignFormSection.CAMPAIGN,
    next: CampaignFormSection.SEGMENT,
    completed: false,
    id: 'step1',
  },
  {
    label: 'Decide on segment',
    stageLevel: 1,
    state: Status.Waiting,
    formStep: CampaignFormSection.SEGMENT,
    next: CampaignFormSection.TEMPLATE,
    completed: false,
    id: 'step2',
  },
  {
    label: 'Decide on message',
    stageLevel: 2,
    state: Status.Waiting,
    formStep: CampaignFormSection.TEMPLATE,
    next: CampaignFormSection.SCHEDULE,
    completed: false,
    id: 'step3',
  },
  {
    label: 'Choose when to send',
    stageLevel: 3,
    state: Status.Waiting,
    formStep: CampaignFormSection.SCHEDULE,
    next: CampaignFormSection.REVIEW,
    completed: false,
    id: 'step4',
  },
  {
    label: 'Review and launch',
    stageLevel: 4,
    state: Status.Waiting,
    formStep: CampaignFormSection.REVIEW,
    next: '',
    completed: false,
    id: 'step5',
  },
];

export const TEMPLATE_FORM_CARDS = [
  {
    width: '31%',
    isChecked: true,
    label: 'Existing content',
    description: 'Choose an existing email template',
    radioName: 'template-type',
    radioValue: TemplateType.EXISTING,
    style: {},
    isDisabled: false,
  },
  {
    width: '31%',
    isChecked: false,
    label: 'New content',
    description: 'Create a new email message',
    radioName: 'template-type',
    radioValue: TemplateType.NEW,
    style: {},
    isDisabled: false,
  },
];

export const CAMPAIGN_FORM_CARDS = [
  {
    width: '30%',
    isChecked: true,
    label: 'Standard Campaign',
    description: 'Send messages to your segments on a schedule or when specific events occur',
    radioName: 'campaign-type',
    radioValue: CampaignTypes.STANDARD,
    style: {},
    isDisabled: false,
  },
];

export const FORM_NAV_ELEMENTS = '[data-test-component="LeftNavItem"]';
export const FORM_SECTIONS_LINK = 'stencil-react-left-nav-item-wrapper';

export const TIMEZONES = [
  {
    label: 'UTC, GMT, WET',
    value: 'UTC+00:00',
  },
  {
    label: 'CET, WAT, WEDT',
    value: 'UTC+01:00',
  },
  {
    label: 'CAT, EET, CEDT, SAST',
    value: 'UTC+02:00',
  },
  {
    label: 'AST, EAT, EEDT, MSK, IDT',
    value: 'UTC+03:00',
  },
  {
    label: 'IRST',
    value: 'UTC+03:30',
  },
  {
    label: 'GST, GET, VOLT',
    value: 'UTC+04:00',
  },
  {
    label: 'AFT, IRDT',
    value: 'UTC+04:30',
  },
  {
    label: 'PKT, TJT, TMT, UZT',
    value: 'UTC+05:00',
  },
  {
    label: 'IST, SLST',
    value: 'UTC+05:30',
  },
];

export const INVALID_DATE = 'Invalid Date';
export const MAX_ALLOWED_NAME_LENGTH = 64;
export const MAX_ALLOWED_DESCRIPTION_LENGTH = 100;

export const DEFAULT_CAMPAIGN_FORM_STATE = {
  segmentDetails: {
    segmentType: '',
    segmentName: '',
    segmentId: '',
  },
  templateDetails: {
    messageTemplateName: '',
    fromAddress: null,
  },
  campaignDetails: {
    frequency: Frequency.ONCE,
    startTime: '',
    endTime: '',
    timeZone: '',
    sendImmediate: false,
  },
  error: {},
  currentActiveStep: '',
  isValid: false,
  isSubmitSuccess: false,
};

export const DEFAULT_TEST_EMAIL_DETAILS = {
  status: '',
  response: '',
};
